import { UserId } from '@business/entities/account';
import { DealStatus } from '@business/entities/deal';
import { ProjectStatus } from '@business/entities/project';
import { TagId } from '@business/entities/tag';
import { PageQuery } from '../common';
import { OrgId } from '../organization';
import { TeamId } from '../team';
import { SupportCategoryId } from './../SupportCategories/SupportCategoryResponse';
import { ChannelId } from './../SupportChannel/SupportChannelResponse';
import { CategoryId } from '../category';
import { DashboardInterval, EmailFrequency } from '../dashboard';

export type ReportId = string;
export type ReportModuleId = string;

export interface ReportModulesResponse {
  id: ReportModuleId;
  name: string;
  reports: ReportResponse[];
}

export interface ReportResponse {
  id: ReportId;
  name: string;
  moduleId: ReportModuleId;
  fields: ReportFieldResponse[];
  filters: string[];
  isPaginated: boolean;
  isColored: boolean;
}

export interface ReportFieldResponse {
  name: string;
  type: string;
  title: string;
  sortable: boolean;
  isDate: boolean;
  isTooltip: boolean;
  isReadMore: boolean;
}

export enum DateFilterByEnum {
  createdAt = 'createdAt',
  lastActivity = 'lastActivity',
  completedAt = 'completedAt',
  openedAt = 'openedAt',
}

export enum ReportStatusEnum {
  completed = 'completed',
  opened = 'opened',
  pending = 'pending',
  delivered = 'delivered',
  overdue = 'overdue',
  active = 'active',
  all = 'all',
  yes = 'yes',
  no = 'no',
}

export interface ReportPageQuery extends PageQuery {
  serviceId?: string[];
  classes?: string[];
  dateRange?: string;
  blankDateRange?: string;
  userId?: UserId[];
  channels?: ChannelId[];
  teamId?: TeamId;
  orgId?: OrgId;
  endDate?: number;
  dStatus?: DealStatus;
  pStatus?: ProjectStatus;
  status?: ReportStatusEnum;
  sortBy?: string;
  sortDirection?: string;
  timezone?: string;
  search?: string;
  billingType?: string;
  vendorId?: string[];
  woStatus?: string;
  rmaStatus?: string;
  tags?: TagId[];
  categories?: SupportCategoryId[];
  serviceCategories?: CategoryId[];
  dateFilterBy?: DateFilterByEnum;
  requestId?: number;
  serviceIdInc?: string[];
  serviceIdExc?: string[];
  customFields?: string;
  timeLogStatus?: string;
  subChangeStatus?: string[];
  poStatus?: string;
  poRequest?: string;
  boardId?: string;
  installStatus?: string;
}

export interface LooseObject {
  [key: string]: any;
}

export type MapSchemaTypes = {
  string: string;
  integer: number;
};

export type MapSchema<T extends Record<string, keyof MapSchemaTypes>> = {
  -readonly [K in keyof T]: MapSchemaTypes[T[K]];
};

export type ReportEmailId = string;
export interface ReportEmailResponse {
  id: ReportEmailId;
  frequency: EmailFrequency;
  emails: string[];
}

export interface ReportSettingResponse {
  interval?: DashboardInterval;
  settings?: any;
}
